const actions = {
    setStoreId: async ({commit}, store_id) => {
        commit('setStoreId', store_id)
    },
    setPredDate: async ({commit}, pred_date) => {
        commit('setPredDate', pred_date)
    },
    setGraphSetting: async ({commit}, graph_setting) => {
        commit('setGraphSetting', graph_setting)
    },
    reset: async ({commit}) => {
        commit('setStoreId', null)
        commit('setPredDate', [])
        commit('setGraphSetting', null)
    }
};

export default actions;